/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */

'use strict';
angular
  .module('http.app', [])
  /**
   * Service used to application information via rest service.
   */
  .factory('httpApp', function ($http) {
    /**
     * Get the application information.
     *
     * @returns {Promise} A promise that resolves to the app info object.
     */
    var getAppInfo = function () {
      return $http({
        method: 'GET',
        url: 'api/app/info'
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      getAppInfo: getAppInfo
    };
  });
